import axios from "axios";
import {
  ADDON_LIST_REQUEST,
  ADDON_LIST_SUCCESS,
  ADDON_LIST_FAIL,
  ADDON_SINGLE_REQUEST,
  ADDON_SINGLE_SUCCESS,
  ADDON_SINGLE_FAIL,
  CREATE_ADDON_REQUEST,
  CREATE_ADDON_SUCCESS,
  CREATE_ADDON_FAIL,
  UPDATE_ADDON_REQUEST,
  UPDATE_ADDON_SUCCESS,
  UPDATE_ADDON_FAIL,
  DELETE_ADDON_REQUEST,
  DELETE_ADDON_SUCCESS,
  DELETE_ADDON_FAIL,
} from "constants/addonConstants";
import { REACT_APP_API_URL } from "constants/apiConstants";
import { getProductList, getSingleProduct } from "actions/productActions";
import AddonService from "services/addon-service";

export const getAddonList = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: ADDON_LIST_REQUEST,
    });

    const res = await AddonService.getAddons();
    console.log("🚀 ~ file: addonActions.js:29 ~ getAddonList ~ res:", res);

    dispatch({
      type: ADDON_LIST_SUCCESS,
      payload: res.foundAddons,
    });
  } catch (error) {
    console.log("🚀 ~ file: addonActions.js:36 ~ getAddonList ~ error:", error);
    dispatch({
      type: ADDON_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error,
    });
  }
};

export const getAddonSingle = (addonId) => async (dispatch, getState) => {
  try {
    dispatch({
      type: ADDON_SINGLE_REQUEST,
    });

    const res = await AddonService.getSingleAddon(addonId);
    console.log("🚀 ~ file: addonActions.js:54 ~ getAddonSingle ~ res:", res);

    dispatch({
      type: ADDON_SINGLE_SUCCESS,
      payload: res.foundAddon,
    });
  } catch (error) {
    console.log(
      "🚀 ~ file: addonActions.js:61 ~ getAddonSingle ~ error:",
      error
    );
    dispatch({
      type: ADDON_SINGLE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error,
    });
  }
};

export const createNewAddon = (addon) => async (dispatch, getState) => {
  try {
    dispatch({
      type: CREATE_ADDON_REQUEST,
    });

    const res = await AddonService.createAddons(addon);
    console.log("🚀 ~ file: addonActions.js:53 ~ createNewAddon ~ res:", res);
    dispatch(getProductList());
    dispatch(getSingleProduct(addon.product));

    dispatch({
      type: CREATE_ADDON_SUCCESS,
      payload: res,
    });
  } catch (error) {
    console.log(
      "🚀 ~ file: addonActions.js:61 ~ createNewAddon ~ error:",
      error
    );
    dispatch({
      type: CREATE_ADDON_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error,
    });
  }
};

export const addonUpdating = (addonId, addon) => async (dispatch, getState) => {
  try {
    dispatch({
      type: UPDATE_ADDON_REQUEST,
    });

    const res = await AddonService.editAddons(addonId, addon);
    console.log("🚀 ~ file: addonActions.js:105 ~ res:", res);

    dispatch(getProductList());
    dispatch(getSingleProduct(addon.product));

    dispatch({
      type: UPDATE_ADDON_SUCCESS,
      payload: res,
    });
  } catch (error) {
    console.log("🚀 ~ file: addonActions.js:112 ~ error:", error);
    dispatch({
      type: UPDATE_ADDON_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error,
    });
  }
};

export const addonDeleting = (addonId) => async (dispatch, getState) => {
  try {
    dispatch({
      type: DELETE_ADDON_REQUEST,
    });

    // const { adminLogin: { adminInfo } } = getState();

    // const config = {
    //   headers: {
    //     Authorization: adminInfo.token
    //   }
    // }

    const res = await axios.delete(
      `${REACT_APP_API_URL}/admin/services/${addonId}`
    );

    dispatch({
      type: DELETE_ADDON_SUCCESS,
      payload: res,
    });
  } catch (error) {
    dispatch({
      type: DELETE_ADDON_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error,
    });
  }
};
